// 手机正则
export const phoneRule = (val) => /^1(3|4|5|6|7|8|9)\d{9}$/.test(val)
// 邮箱正则
export const emailRule = (val) =>
  /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/.test(
    val
  )
// 密码正则
export const pwdRule = (val) => /^(?=.*[a-z])(?=.*\d)[^]{8,16}$/.test(val)
